"use client";

import { c as _c } from "react/compiler-runtime";
import { Button } from "@opensea/next-ui-kit";
import { SwapCalls } from "@opensea/ui-kit/icons";
import { TopLevelPath } from "@/lib/helpers/url";
export function SwapIconButton() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Button className="md:px-4" href={TopLevelPath.swap} icon={SwapCalls} variant="ghost" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}